import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from 'primereact/utils';
import { AuthField } from "./modules/AuthLayout";
import { send, notify } from "../services/NotificationService";
import { sendMessage } from "../data/contact";

export default function Contact() {
    const navigate = useNavigate();
    const [sending, setSending] = useState(false);

    const formik = useFormik({
        initialValues: {
            sender: "",
            message: ""
        },
        validate: (data) => {
            const errors = {};
            if (!data.sender) {
                errors.sender = "Indiquez une adresse e-mail pour que nous puissions vous répondre.";
            }
            if (!data.message) {
                errors.message = "Votre message est vide.";
            }
            return errors;
        },
        onSubmit: async (data) => {
            setSending(true);
            try {
                const response = await sendMessage(data);
                if (response) {
                    send("success", "Message envoyé, nous revenons vers vous rapidement.");
                    notify();
                    formik.resetForm();
                } else {
                    send("warning", "Le message n'a pas pu être envoyé. Veuillez réessayer.");
                    notify();
                }
            } catch (error) {
                send("error", "Le message n'a pas pu être envoyé. Veuillez réessayer.");
                notify();
            } finally {
                setSending(false);
            }
        }
    });

    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    return (
        <div className="lk-page lk-contact">
            <header className="lk-page-header">
                <div className="lk-page-header__title">
                    <span className="lk-page-header__icon"><i className="pi pi-envelope" aria-hidden="true"></i></span>
                    <div>
                        <p className="lk-kicker">Support</p>
                        <h1>Contactez-nous</h1>
                        <p className="lk-page-header__subtitle">Une question sur votre espace Lokapp ? Notre équipe vous répond rapidement.</p>
                    </div>
                </div>
            </header>

            <div className="lk-contact-grid">
                <aside className="lk-card lk-contact-info">
                    <h2 className="lk-card__title">Nous joindre</h2>
                    <p>Écrivez-nous directement ou utilisez le formulaire : nous répondons généralement sous un jour ouvré.</p>
                    <a className="lk-contact-info__item" href="mailto:contact@lokapp.fr">
                        <i className="pi pi-at" aria-hidden="true"></i>
                        <span>contact@lokapp.fr</span>
                    </a>
                    <a className="lk-contact-info__item" href="https://lokapp.fr/" target="_blank" rel="noopener noreferrer">
                        <i className="pi pi-globe" aria-hidden="true"></i>
                        <span>lokapp.fr</span>
                    </a>
                </aside>

                <section className="lk-card">
                    <h2 className="lk-card__title" style={{ marginBottom: "1rem" }}>Envoyer un message</h2>
                    <form onSubmit={formik.handleSubmit} noValidate>
                        <AuthField id="sender" label="Votre adresse e-mail" error={isFormFieldInvalid('sender') ? formik.errors.sender : null}>
                            <InputText
                                id="sender"
                                name="sender"
                                type="email"
                                autoComplete="email"
                                value={formik.values.sender}
                                onChange={(e) => formik.setFieldValue('sender', e.target.value)}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('sender') })}
                            />
                        </AuthField>
                        <AuthField id="message" label="Votre message" error={isFormFieldInvalid('message') ? formik.errors.message : null}>
                            <InputTextarea
                                id="message"
                                name="message"
                                rows={7}
                                autoResize
                                value={formik.values.message}
                                onChange={(e) => formik.setFieldValue('message', e.target.value)}
                                className={classNames({ 'p-invalid': isFormFieldInvalid('message') })}
                            />
                        </AuthField>
                        <div className="lk-form-actions">
                            <Button type="submit" label="Envoyer" icon="pi pi-send" loading={sending} />
                            <Button type="button" label="Annuler" severity="secondary" outlined onClick={() => navigate(-1)} />
                        </div>
                    </form>
                </section>
            </div>
        </div>
    );
}
